import { Member } from '@tribeplatform/gql-client/types'

export const BannerPlaceholder = ({ member }: { member: Member }) => {
  const banners = [
    '/images/banners/banner-1.jpg',
    '/images/banners/banner-2.jpg',
    '/images/banners/banner-3.jpg',
    '/images/banners/banner-4.jpg',
    '/images/banners/banner-5.jpg',
  ]
  let index = 0

  if (member?.id) {
    index = member?.id?.charCodeAt(member?.id?.length - 1) % banners.length
  }
  return <img src={banners[index]} alt={member?.name} />
}
